import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '../api.js'
import { useSessao } from '../sessao.jsx'
import { Campo, Erro, Aviso } from '../componentes/basicos.jsx'

/** Destino dos links de convite e de recuperação de senha. */
export default function DefinirSenha() {
  const [parametros] = useSearchParams()
  const token = parametros.get('token')
  const { recarregar } = useSessao()
  const navegar = useNavigate()

  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState(null)
  const [enviando, setEnviando] = useState(false)

  async function enviar(evento) {
    evento.preventDefault()
    setEnviando(true)
    setErro(null)
    try {
      await api.post('/auth/definir-senha', { token, senha })
      await recarregar()
      navegar('/', { replace: true })
    } catch (e) {
      setErro(e)
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="app" style={{ paddingBottom: 0, justifyContent: 'center' }}>
      <main className="conteudo" style={{ maxWidth: 420 }}>
        <h1>Defina sua senha</h1>

        {!token && <Aviso tipo="erro">Link sem token. Peça um novo convite ao administrador.</Aviso>}

        {token && (
          <form className="cartao pilha" onSubmit={enviar}>
            <Campo rotulo="Senha" dica="Mínimo de 8 caracteres.">
              <input type="password" value={senha} autoComplete="new-password" required minLength={8}
                     onChange={(e) => setSenha(e.target.value)} />
            </Campo>

            <Erro erro={erro} />

            <button type="submit" className="botao-principal botao-largo" disabled={enviando}>
              {enviando ? 'Salvando…' : 'Salvar e entrar'}
            </button>
          </form>
        )}
      </main>
    </div>
  )
}
